import { combineReducers } from 'redux';

import roster from 'components/roster-portal/reducers';

import {
  userDetails,
  preferences,
  grants,
  organisationPreferences,
  planGroups,
  planUnits,
  employeePlanUnits,
  publicPlanUnits,
  dutyCodes,
  dhts,
  holidays,
  workAgreements,
  tenantDetails
} from './commonReducers';

const rootReducer = combineReducers({
  roster,
  userDetails,
  tenantDetails,
  preferences,
  grants,
  organisationPreferences,
  planGroups,
  planUnits,
  employeePlanUnits,
  publicPlanUnits,
  dutyCodes,
  dhts,
  holidays,
  workAgreements
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
